import { useSoundEnabled, useEffectsToggle } from "./PublicCelebrationController";

export default function SpectatorControls() {
  const [soundOn, setSoundOn] = useSoundEnabled();
  const [effectsOn, setEffectsOn] = useEffectsToggle();

  return (
    <div className="flex items-center gap-2" role="group" aria-label="Spectator controls">
      <ToggleButton
        label={soundOn ? "Sound on" : "Sound off"}
        active={soundOn}
        onClick={() => setSoundOn(!soundOn)}
        icon={soundOn ? <SoundOnIcon /> : <SoundOffIcon />}
      />
      <ToggleButton
        label={effectsOn ? "Effects on" : "Effects off"}
        active={effectsOn}
        onClick={() => setEffectsOn(!effectsOn)}
        icon={<EffectsIcon active={effectsOn} />}
      />
    </div>
  );
}

function ToggleButton({ label, active, onClick, icon }: { label: string; active: boolean; onClick: () => void; icon: React.ReactNode }) {
  return (
    <button
      onClick={onClick}
      aria-label={label}
      title={label}
      className="flex items-center justify-center w-9 h-9 rounded-lg transition-all duration-200"
      style={{
        background: active ? "rgba(0,201,128,0.15)" : "rgba(159,182,172,0.1)",
        border: `1px solid ${active ? "rgba(0,201,128,0.3)" : "rgba(159,182,172,0.15)"}`,
        color: active ? "#00C980" : "#9FB6AC",
      }}
    >
      {icon}
    </button>
  );
}

function SoundOnIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="currentColor" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
    </svg>
  );
}

function SoundOffIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="11,5 6,9 2,9 2,15 6,15 11,19" fill="currentColor" />
      <line x1="23" y1="9" x2="17" y2="15" />
      <line x1="17" y1="9" x2="23" y2="15" />
    </svg>
  );
}

function EffectsIcon({ active }: { active: boolean }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
        fill={active ? "currentColor" : "none"} />
      {!active && <line x1="4" y1="4" x2="20" y2="20" strokeWidth="2.5" />}
    </svg>
  );
}
